<p-toast [style]="{marginTop: '50px'}"></p-toast>
<div class="spinner" *ngIf="isLoading">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
</div>
<router-outlet></router-outlet>